define('modules/lp_leads/views/lead_listing_empty_view',['require','exports','module','base/itemview','ldsh!../templates/lead_listing_empty_item'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/lead_listing_empty_item")
  });

});

